/**
 * Set by DataTable on phone: time cells that were not given an explicit
 * pattern print `fmtTimeCompact` ("HH:mm:ss" today, "MM-dd HH:mm" before,
 * "yyyy-MM-dd" in another year)
 * so the time column leaves room for the numbers. Full UTC stays on hover.
 */
import { createContext, useContext } from "react";

export const CompactTimeContext = createContext(false);

export function useCompactTime(): boolean {
  return useContext(CompactTimeContext);
}
